import client from "./client";

export default {
    async getLeaseTemplates(filters) {
        return client.parseResponse(await client.get("/lease-templates", filters));
    },
    async createLeaseTemplate(data) {
        return client.parseResponse(await client.post("/lease-templates", data));
    },
    async editLeaseTemplate(data) {
        return client.parseResponse(await client.put(`/lease-templates/${data.id}`, data));
    },
    async deleteLeaseTemplate(data) {
        return client.parseResponse(await client.delete(`/lease-templates/${data.id}`));
    },
    async getLeaseTemplateById(id) {
        return client.parseResponse(await client.get(`/lease-templates/${id}`));
    }

};
